import React from 'react';
import './StatsCard.css';

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: string;
  color: 'blue' | 'red' | 'green' | 'gray' | 'purple' | 'orange';
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  color
}) => {
  return (
    <div className={`stats-card ${color}`}>
      <div className="stats-card-header">
        <div className="stats-icon">{icon}</div>
        <h3 className="stats-title">{title}</h3>
      </div>
      
      <div className="stats-value">{value}</div>
      
      {subtitle && (
        <div className="stats-subtitle">{subtitle}</div>
      )}
    </div>
  );
};

export default StatsCard; 